import { createSlice } from '@reduxjs/toolkit';
import { setIsLoading } from '../isLoading.slice';
import axios from 'axios';
import { logOut } from '../../../resources/utils';


export const aceptacionPoliticasSlice = createSlice({
    name: 'aceptacion_politicas',
    initialState: {
        item: {},
        message: "",
        error: "",
    },
    reducers: {
        initialStateParent: (state, action) => {
            return {
                item: {},
                message: "",
                process: "",
                error: "",
            }
        },
        setAceptacionPolitica: (state, action) => {
            return {
                item: action.payload,
                message: "",
                error: "",
            }
        },
        setProcess: (state, action) => {
            return {
                items: [],
                item: {},
                process: true,
                message: "",
                error: "",
            }
        },
        setMessage: (state, action) => {
            return {
                items: [],
                item: {},
                message: action.payload,
                error: "",
            }
        },
        setError: (state, action) => {
            return {
                items: [],
                item: {},
                message: "",
                error: action.payload,
            }
        },
    }
})

export const getAceptacionPoliticaThunk = (ci_padre) => dispatch => {
    dispatch(setIsLoading(true));
    axios.get(`/aceptacion_politicas/${ci_padre}`)
        .then(res => {
            if (res.status === 200) {
                dispatch(setAceptacionPolitica(res.data))
            }
        })
        .catch(res => {
            if (res.response.status === 498) {
                logOut();
            } else {
                dispatch(setError(res.response?.data))
            }
        })
        .finally(() => dispatch(setIsLoading(false)))
};

export const aceptarPoliticaThunk = (ci_padre) => dispatch => {
    dispatch(setIsLoading(true));
    axios.put(`/aceptacion_politicas/aceptar_politica_privacidad/${ci_padre}`)
        .then(res => {
            if (res.status === 200) {
                dispatch(setMessage(res.data.data))
            }
        })
        .catch(res => {
            if (res.response.status === 498) {
                logOut();
            } else {
                dispatch(setError(res.response?.data))
            }
        })
        .finally(() => dispatch(setIsLoading(false)))
};



export const { initialStateParent,
    setAceptacionPolitica,
    setParent,
    setMessage,
    setError,
     } = aceptacionPoliticasSlice.actions;

export default aceptacionPoliticasSlice.reducer;